import { Dispatch, useCallback } from "react";
import { PlanoActions, PlanoActionUnion } from "./Plano.Actions";
import PlanoService from "../../Data/Services/PlanoService";
import { IPlanoEffects } from "./Interfaces/IPlanoEffects";
import { History } from "history";

export type PlanoEffectsType = (
  dispatch: Dispatch<PlanoActionUnion>
) => IPlanoEffects;

export const PlanoEffects: PlanoEffectsType = (
  dispatch: Dispatch<PlanoActionUnion>
) => ({
  getPlano: useCallback(
    async (identifier: string, history: History) => {
      try {
        dispatch(PlanoActions.setLoading(true));
        const { data } = await PlanoService.fetchPlano(identifier);
        dispatch(PlanoActions.getPlanosSuccess(data));
      } catch (err: any) {
        history.push("/");
      } finally {
        dispatch(PlanoActions.setLoading(false));
      }
    },
    [dispatch]
  ),
  getAllPlanos: useCallback(async () => {
    try {
      dispatch(PlanoActions.setLoading(true));
      const { data } = await PlanoService.fetchAllPlanos();
      dispatch(PlanoActions.getAllPlanosSuccess(data));
    } catch (err: any) {
    } finally {
      dispatch(PlanoActions.setLoading(false));
    }
  }, [dispatch]),
});
